const CONTENTFUL_IMAGE_HOST = 'images.ctfassets.net'

export const contentfulImageUrl = (src, width, quality = 55) => {
  if (!src || src.indexOf(CONTENTFUL_IMAGE_HOST) === -1) {
    return src
  }

  const absoluteSrc = src.indexOf('//') === 0 ? `https:${src}` : src
  const [path, query = ''] = absoluteSrc.split('?')
  const params = query
    .split('&')
    .filter(Boolean)
    .filter(param => !/^(w|q|fm)=/.test(param))

  params.push(`w=${width}`, `q=${quality}`, 'fm=webp')
  return `${path}?${params.join('&')}`
}

export const contentfulImageSrcSet = (src, widths, quality = 55) =>
  src && src.indexOf(CONTENTFUL_IMAGE_HOST) !== -1
    ? widths
        .map(width => `${contentfulImageUrl(src, width, quality)} ${width}w`)
        .join(', ')
    : undefined
